<template class="main">
  <div class="wrap">
    <Layout class="pull-left" style="height: 100%;">
      <Sider class="nav-bar pull-left" :width="150">
        <img v-if="logo" :src="logo" width="120" alt="" class="lhlh-logo" />
        <div v-else class="nav-logo">
          <img src="/static/images/logo.png" alt="" />
        </div>
        <hr class="map-list-hr" :class="{ 'lhlh-hr': logo }" />
        <Menu active-name="1-2" theme="dark" width="auto">
          <router-link
            :key="nav.type"
            v-for="nav in navTopList"
            :to="nav.router"
          >
            <MenuItem
              :name="nav.name"
              :class="{
                'ivu-menu-item-active ivu-menu-item-selected':
                  curPath === nav.router
              }"
            >
              {{ nav.name }}
            </MenuItem>
          </router-link>
        </Menu>
      </Sider>
    </Layout>
    <Content></Content>
  </div>
</template>

<script>
import Content from "./Content.vue";
import "../assets/stylesheets/main.scss";

export default {
  data() {
    return {
      navTopList: [
        {
          name: "日程管理",
          router: "/map",
          className: "nav-command",
          type: "schedule"
        },
        {
          name: "城市作战图",
          router: "/customers",
          className: "nav-cases",
          type: "client"
        },
        // {
        //   name: "成员管理",
        //   router: "/members",
        //   className: "nav-watch",
        //   type: "member"
        // },
        {
          name: "对比分析",
          router: "/compare",
          className: "nav-watch",
          type: "compare"
        }
      ],
      curPath: this.$route.path
    };
  },
  components: {
    Content
  },
  computed: {
    logo() {
      let type = sessionStorage.getItem("type");
      if (type) {
        document.title =
          "亿景排班 — 外勤排班、销售排班、外勤日程、销售日程、外勤排班软件、外勤日程规划系统、销售排班软件、销售排班系统、销售如此规划系统、外勤排班系统";
        return "";
      }
      document.title = "客户城市分布图";
      return "../../static/images/logo_new2.png";
    }
  },
  methods: {
    getCurPath() {
      this.curPath = this.$route.path;
    }
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    $route: "getCurPath"
  },
  mounted() {
    let type = sessionStorage.getItem("type");
    let role = sessionStorage.getItem("role");
    if (!type) {
      if (role.toLowerCase() !== "central admin") {
        this.navTopList = [
          {
            name: "城市作战图",
            router: "/customers",
            className: "nav-cases",
            type: "client"
          }
        ];
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
* {
  padding: 0;
  margin: 0;
}
#wrap {
  width: 100%;
  height: 100%;
}
.nav-logo {
  line-height: 40px;
  font-size: 20px;
  color: #fff;
  margin-top: 10px;
  img {
    width: 80%;
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue